import $ from 'jquery';
import { requestJson } from 'src/utils/request';
import { sendFormData } from 'ts/helpers/addToCartHandler';

function wishlistProductVariantsSelectorTemplate(productCode, variantTypeLabel, variantOptions) {
  return `<div class="product-variants">
              <div class="form-select">
                  <select class="form-select__select">
                      <option value="${productCode}" disabled="disabled" selected="selected">
                          Select a size
                      </option>
                      ${variantOptions.map((variantOption) =>
                        variantOption.availableForPurchase
                          ? `<option value="${variantOption.productCode}">
                            ${variantOption.formatVariant}
                          </option>`
                          : ''
                      )}
                  </select>
                  <span class="form-select__bar"></span>
              </div>
        </div>`;
}

function validateATBVariants(ATBForm, e) {
  const ATBButton = ATBForm.find('button[type=submit]');
  const variantsSelector = ATBForm.find('select');
  const variantsSelectedOption = variantsSelector.find(':selected');

  if (!variantsSelectedOption.index()) {
    variantsSelector.addClass('parsley-error');
    ATBButton.attr('disabled', 'disabled');
    ATBButton.addClass('disabled');
    if (e) {
      e.preventDefault();
    }
  } else {
    variantsSelector.removeClass('parsley-error');
    ATBButton.removeAttr('disabled');
    ATBButton.removeClass('disabled');
  }
}

function onProductVariantsSelectorChange(ATBForm) {
  const variantsSelector = ATBForm.find('select');

  variantsSelector.on('change', function () {
    ATBForm.has(this).find('[name=productCodePost]').val($(this).val());
    validateATBVariants(ATBForm.has(this));
  });
}

function showProductVariantsSelector(ATBForm, variantOptions) {
  const ATBDisabledButtonWrapper = ATBForm.find('.add-to-cart-disabled-button');
  const productUrl = $('.product-list__item').has(ATBForm).find('a').attr('href');
  const productVariantType = ATBForm.data('variant-type');
  const productCode = ATBForm.find('[name=productCodePost]').val();
  const ATBButton = ATBForm.find('button[type=submit]');

  const areAnyProductsAvailableForPurchase = variantOptions.some((option) => option.availableForPurchase);
  let variantSelectorTemplate = wishlistProductVariantsSelectorTemplate(
    productCode,
    productVariantType,
    variantOptions
  );

  if (!areAnyProductsAvailableForPurchase) {
    variantSelectorTemplate = `<a href="${productUrl}" >${window.globalWishlist.unavailableVariantsProductMessage}</a>`;
    ATBDisabledButtonWrapper.addClass('empty');
    ATBButton.hide();
  }

  ATBDisabledButtonWrapper.empty()
    .append(variantSelectorTemplate)
    .removeClass('add-to-cart-disabled-button')
    .addClass('wishlist-atb-cta__product-variants');
  ATBButton.on('click', (e) => validateATBVariants(ATBForm, e));
}

function getProductVariants(productCode) {
  return requestJson(`/api/v1/product/${productCode}/variants`);
}

export function showVariantSelector(form) {
  const ATBForm = $(form);
  const submitButton = ATBForm.find('[type="submit"]');

  const productCode = ATBForm.find('[name=productCodePost]').val();
  submitButton.attr('disabled', '');

  getProductVariants(productCode)
    .then((variantOptions) => {
      showProductVariantsSelector(ATBForm, variantOptions.entries);
      onProductVariantsSelectorChange(ATBForm);
    })
    .finally(() => {
      submitButton.removeAttr('disabled');
    });
}

function wishlistATB() {
  $('.add_to_cart_form').on('submit', (e) => {
    e.preventDefault();
    const form = e.target;
    const isVariantPlaceholderExists = $(form).find('.add-to-cart-disabled-button').length;

    if (isVariantPlaceholderExists) {
      showVariantSelector(form);
    } else {
      sendFormData(form);
    }
  });
}

export default wishlistATB;
